// 상세 화면 값 표시 헬퍼 (도메인 무관 공용).

// 여러 조각을 합칠 때 null / undefined / "null" / 공백을 걸러내고,
// 남는 게 없으면 undefined를 반환한다.
// ("null null", "undefined, undefined" 같은 문자열이 화면에 노출되는 것을 방지)
export const joinParts = (
  parts: unknown[],
  sep = " "
): string | undefined => {
  const clean = parts
    .filter(
      (p) =>
        p !== null &&
        p !== undefined &&
        String(p).trim() !== "" &&
        String(p).toLowerCase() !== "null"
    )
    .map((p) => String(p).trim());
  return clean.length ? clean.join(sep) : undefined;
};
